import { render } from "./ProgramTimetableWeek.vue?vue&type=template&id=83829690&scoped=true"
import script from "./ProgramTimetableWeek.vue?vue&type=script&lang=js"
export * from "./ProgramTimetableWeek.vue?vue&type=script&lang=js"

import "./ProgramTimetableWeek.vue?vue&type=style&index=0&id=83829690&scoped=true&lang=css"

import exportComponent from "/Volumes/Evolve/WorkSpace/MinonowaRadio/Ver2/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83829690"]])

export default __exports__